import React, { useCallback } from 'react'
import { getConfig } from '../../../../config'
import { InstallType } from '../../../../lib/hooks/install-eligibility'
import { Cookie, setCookie } from '../../../../lib/utils/cookies'
import { day } from '../../../../lib/utils/time'
import {
  BrowserSpecificExtensionInstallButtonBase,
  BrowserSpecificExtensionInstallButtonProps,
} from './browser-specific'

const { downloadUrl } = getConfig().products.extension.firefox

export type FirefoxInstallButtonProps = BrowserSpecificExtensionInstallButtonProps

export const FirefoxInstallButton: React.FC<FirefoxInstallButtonProps> = (props) => {
  const handleInstall = useCallback(() => {
    setCookie(Cookie.grInstallSource, 'funnel', day)
    window.location.href = downloadUrl
  }, [])

  return (
    <BrowserSpecificExtensionInstallButtonBase
      {...props}
      installUrl={downloadUrl}
      onClick={handleInstall}
      install={InstallType.Firefox}
    />
  )
}
